import {
  createContext,
  type Dispatch,
  type ReactNode,
  type SetStateAction,
  useMemo,
  useState,
} from 'react';

type AppUIContextProps = {
  isSearchExpanded: boolean;
  /**
   * The current value of the search input in the navbar.
   */
  search: string;
  setIsSearchExpanded: Dispatch<SetStateAction<boolean>>;
  setSearch: Dispatch<SetStateAction<string>>;
};

export const AppUIContext = createContext<AppUIContextProps>({
  isSearchExpanded: false,
  search: '',
  setIsSearchExpanded: () => {},
  setSearch: () => {},
});

type AppUIProviderProps = {
  readonly children: ReactNode;
};

export const AppUIProvider = ({ children }: AppUIProviderProps) => {
  const [search, setSearch] = useState('');
  const [isSearchExpanded, setIsSearchExpanded] = useState<boolean>(false);

  const context = useMemo(() => {
    return {
      isSearchExpanded,
      search,
      setIsSearchExpanded,
      setSearch,
    };
  }, [isSearchExpanded, search, setIsSearchExpanded, setSearch]);

  return (
    <AppUIContext.Provider value={context}>{children}</AppUIContext.Provider>
  );
};
